// src/components/BreadcrumbBar.js
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaHome, FaChevronRight } from "react-icons/fa";

/**
 * @file BreadcrumbBar.js
 * @description Navigation component that displays hierarchical path segments (Home -> Dashboard -> ...).
 */
/**
 * BreadcrumbBar Component.
 * Maps URL segments to readable names and renders clickable navigation trail.
 */
export default function BreadcrumbBar() {
  const location = useLocation();

  // Split the path into segments (e.g. /dashboard/tenants)
  const pathSegments = location.pathname.split("/").filter(Boolean);

  // Map of path segments to display names
  const routeNameMap = {
    "billing": "Financials & Usage",
    "analytics": "Usage Analytics",
    "tenants": "Tenant Management",
    "health": "System Health",
    "modules": "Feature Flags",
    "security": "Admin Access",
    "plans": "Platform Settings",
    "audit": "Audit Logs",
    "support": "Support / Tickets"
  };

  // Build breadcrumb items (convert slug to readable name)
  const crumbs = pathSegments.map((segment, index) => {
    const path = "/" + pathSegments.slice(0, index + 1).join("/");

    // Check if we have a direct mapping for this segment
    let name = routeNameMap[segment.toLowerCase()];

    // Fallback to auto-capitalization if no mapping found
    if (!name) {
      name = segment
        .split("-")
        .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
        .join(" ") || "Dashboard";
    }

    return { name, path };
  });

  return (
    <nav
      className="breadcrumb-row d-flex align-items-center mb-4"
      aria-label="Breadcrumb"
    >
      {/* Home Icon (links to dashboard root) */}
      <Link to="/" className="text-muted text-decoration-none d-flex align-items-center">
        <FaHome size={14} className="me-2" />
      </Link>

      {/* <FaChevronRight size={12} className="text-muted mx-1" /> */}

      {/* Always show Dashboard root link */}
      {/* <Link
        to="/"
        className={`text-decoration-none fw-medium ${pathSegments.length === 0 ? "text-dark fw-semibold" : "text-muted"
          }`}
      >
        Dashboard
      </Link> */}

      {/* Render subpages (clickable except last one) */}
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;
        return (
          <React.Fragment key={crumb.path}>
            <FaChevronRight size={12} className="text-muted mx-1" />
            {isLast ? (
              <span className="text-dark fw-semibold">{crumb.name}</span>
            ) : (
              <Link
                to={crumb.path}
                className="text-muted text-decoration-none"
              >
                {crumb.name}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
